import React from 'react';
import { Linkedin, Youtube } from 'lucide-react';

const NAV_LINKS = [
  { href: '/about', label: 'About Us', testid: 'header-about' },
  { href: '/?view=deck', label: 'The Deck', testid: 'header-deck' },
  { href: '/consulting', label: 'Services', testid: 'header-services' },
  { href: '/blog', label: 'Blog', testid: 'header-blog' },
  { href: '/contact', label: 'Contact Us', testid: 'header-contact' },
];

export const SiteHeader = () => {
  return (
    <header className="w-full pt-4 pb-4 mb-6" data-testid="site-header">
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
        {/* Left: Nav links */}
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="font-body text-sm text-[#d4c4a8]/70 hover:text-[#e89b47] transition-colors"
              data-testid={link.testid}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Right: Social icons + CTA */}
        <div className="flex items-center gap-2">
          <a
            href="https://www.linkedin.com/in/charuverma/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full text-[#d4c4a8]/70 hover:text-[#e89b47] hover:bg-[#e89b47]/10 transition-colors"
            data-testid="header-linkedin"
          >
            <Linkedin className="w-5 h-5" />
          </a>
          <a
            href="https://www.youtube.com/@themarketingtarot/videos"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="The Marketing Tarot Podcast on YouTube"
            title="The Marketing Tarot Podcast"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full text-[#d4c4a8]/70 hover:text-[#e89b47] hover:bg-[#e89b47]/10 transition-colors"
            data-testid="header-youtube"
          >
            <Youtube className="w-5 h-5" />
          </a>
          <a
            href="https://calendly.com/marketingtarot/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 inline-flex items-center gap-2 h-10 px-5 text-sm bg-gradient-to-r from-[#e89b47] to-[#d4883a] text-[#0a1628] hover:from-[#e89b47]/90 hover:to-[#d4883a]/90 font-display tracking-widest shadow-lg shadow-[#e89b47]/25 rounded-xl transition-all hover:scale-105 hover:shadow-xl hover:shadow-[#e89b47]/30"
            data-testid="header-book-call-btn"
          >
            Book a Clarity Call
          </a>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
